import { render, staticRenderFns } from "./IncomeTax.vue?vue&type=template&id=c66a5c34&scoped=true&"
import script from "./IncomeTax.vue?vue&type=script&lang=js&"
export * from "./IncomeTax.vue?vue&type=script&lang=js&"
import style0 from "./IncomeTax.vue?vue&type=style&index=0&id=c66a5c34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66a5c34",
  null
  
)

export default component.exports